/**
 * This file contains the ONLY BigBingo function that should be called directly
 * (as opposed to accessed via ConversionContext). For further documentation on
 * why this is see bigbingo-internals.js and/or
 * http://khanacademy.org/r/conversioncontext.
 */
import * as BigBingoInternals from "./bigbingo-internals.ts";
import {actions, store} from "./store.ts";
import type {MinorConversionData} from "./types.ts";

/**
 * Marks an array of "minor" conversions, representing low-level events such
 * as page requests that will inherit specific LearningTimeInfo from the last
 * major conversion.
 */
export const markMinorConversions = (
    conversions: ReadonlyArray<MinorConversionData>,
): Promise<Response | null | undefined> => {
    const formatted = BigBingoInternals.formatConversions(conversions);
    return store.dispatch(actions.markMinorConversions(formatted));
};
